import { Field } from 'Util/Query';

export class BeautyAdventCalendarQuery {
    getQuery() {
        return new Field('getBeautyAdvent')
            .addFieldList(this.getFields());
    }

    getFields() {
        return [
            'enable',
            'endDate',
            this._getHeroFields(),
            this._getProductFields(),
            'sticker_background',
            'sticker_color',
        ];
    }

    _getHeroFields() {
        return new Field('hero')
            .addFieldList(['title', 'subtitle', 'image', 'background']);
    }

    _getProductFields() {
        return new Field('products')
            .addFieldList([
                'name',
                'url',
                'calendarActiveState',
                'activeDay',
                'calendarDiscountPercent',
                this._getCartRuleSpecialPriceField(),
                this._getPriceRangeField(),
                this._getProductImageFields(),
                'sku',
                'type_id',
                'salable_quantity_oos',
            ]);
    }

    _getCartRuleSpecialPriceFields() {
        return [
            'price',
            'startDate',
            'endDate'
        ];
    }

    _getCartRuleSpecialPriceField() {
        return new Field('cart_rule_special_price').addFieldList(this._getCartRuleSpecialPriceFields());
    }

    _getProductImageFields() {
        return new Field('small_image')
            .addFieldList(['url']);
    }

    _getDiscountField() {
        return new Field('discount')
            .addField('amount_off')
            .addField('percent_off');
    }

    _getFinalPriceField() {
        return new Field('final_price')
            .addField('currency')
            .addField('value');
    }

    _getRegularPriceField() {
        return new Field('regular_price')
            .addField('currency')
            .addField('value');
    }

    _getMinimalPriceFields() {
        return [
            this._getDiscountField(),
            this._getFinalPriceField(),
            this._getRegularPriceField()
        ];
    }

    _getMinimalPriceField() {
        return new Field('minimum_price')
            .addFieldList(this._getMinimalPriceFields());
    }

    _getPriceRangeFields() {
        // Using an array as potentially would want to add maximum price
        return [
            this._getMinimalPriceField()
        ];
    }

    _getPriceRangeField() {
        return new Field('price_range')
            .addFieldList(this._getPriceRangeFields());
    }
}

export default new BeautyAdventCalendarQuery();
